<template>
  <div v-if="!isAuthenticated"
    class="container d-flex justify-content-center align-items-center vh-100 overflow-auto px-3">
    <div class="card shadow-sm p-4 w-100" style="max-width: 25rem;">
      <div class="text-center mb-4">
        <img src="@/assets/logo.png" alt="Melbourne Personal Home Care" class="img-fluid mb-3"
          style="max-height: 150px;" />
        <h3>Sign In</h3>
      </div>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="email" class="form-label">E-mail</label>
          <input type="email" class="form-control" id="email" v-model="email" required />
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <div class="input-group">
            <input :type="showPassword ? 'text' : 'password'" class="form-control" id="password" v-model="password"
              required />

            <button class="btn btn-outline-secondary" type="button" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </button>
          </div>
        </div>


        <div class="d-grid mb-3">
          <button type="submit" class="btn btn-success">Log In</button>
        </div>
        <!-- 
        <div class="d-flex justify-content-between flex-wrap gap-2">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="rememberMe" v-model="rememberMe" />
            <label class="form-check-label" for="rememberMe">
              Remember Me
            </label>
          </div>
          <a href="#" @click.prevent="forgotPassword">Forgot Password?</a>
        </div>
        -->
      </form>
       <p class="mt-4 text-center">
        By signing in, you accept our <a href="/termsofuse">Terms of Use</a> and  <a href="privacypolicy">Privacy Policy</a>
      </p> 
      <div v-if="errorMessage" class="alert alert-danger mt-3">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import { BASE_URL } from '@/config';

export default {
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      errorMessage: '',
      showPassword: false,
      isAuthenticated: false
    };
  },
  created() {
    const token = localStorage.getItem('jwt');
    if (token) {
      this.isAuthenticated = true;
      this.$router.push({ name: 'dashboard' });
    }
  },
  methods: {
    async login() {
      this.errorMessage = '';
      try {
        const response = await axios.post(BASE_URL+'/api/auth/local', {
          identifier: this.email,
          password: this.password
        });

        const { jwt, user } = response.data;

        // Store JWT and timestamp in localStorage

        const issuedAt = new Date().getTime();
        //console.log('Storing JWT and issuedAt:', jwt, issuedAt); // Debug log
        localStorage.setItem('jwt', jwt);
        localStorage.setItem('jwt_issued_at', issuedAt);

        // Store user data in Vuex store
        localStorage.setItem('user', JSON.stringify(user));
        this.$store.commit('setUser', user);

        this.saveUserRole(jwt);

        // Redirect to dashboard
        //this.$router.push({ name: 'dashboard' });

        setTimeout(() => {
        this.$router.push({ name: 'dashboard' });
      }, 200); // 2 millsecond delay

      } catch (error) {
        console.error('An error occurred:', error);
        this.errorMessage = 'Invalid email or password. Please try again.';
      }
    },
    saveUserRole(token) {

      fetch(BASE_URL+'/api/users/me?populate=*', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(data => {

          localStorage.setItem('role', data.role.name);
          //console.log('User Role:', data.role.name);
        })
        .catch(error => {
          console.error('Error fetching user role:', error);
        });

    },

    forgotPassword() {
      alert('Contact Support Office');
    },
    showLicense() {
      //alert('Showing End User License Agreement.');
    }
  }
};
</script>


<style scoped>
.container {
  background: #f8f9fa;
}

.card {
  border-radius: 10px;
}

.btn-success {
  background-color: #000F46;
  border-color: #000F46;
}

.btn-success:hover {
  background-color: #000FAA;
  border-color: #000FAA;
}
</style>
